import { salesInfoApi, salesInfoAfterApi } from "@/libs/api.js";
// import { uleUrl, uleCdn, getCookie } from "@/libs/common";
// import bottomPop from "@/components/yzg/bottomPop.vue";
export default {
  name: "salesData",
  data() {
    return {
      dateList: [
        {
          name: "今日",
          dateRange: 1,
        },
        {
          name: "昨日",
          dateRange: 0,
        },
        {
          name: "7天",
          dateRange: 7,
        },
        {
          name: "30天",
          dateRange: 30,
        },
      ],
      shiList: [
        {
          name: "今日",
          dateRange: 1,
        },
        {
          name: "昨日",
          dateRange: 0,
        },
        {
          name: "前天",
          dateRange: 2,
        },
      ],
      dateIndex: 0,
      date: "",
      sales: {},
      salesInfo: {},
      show: false,
      currentYear: "",
      cityType: null,
    };
  },

  mounted() {
    this.appGetPioltFlag();
    this.getSalesInfo();
    this.currentYear = this.$moment(Date.now()).format("YYYY");
  },
  methods: {
    handleChangeDate(index) {
      // console.log("index", index);
      this.dateIndex = index;
      this.getSales();
    },
    // 销售-累计数据
    getSalesInfo() {
      salesInfoAfterApi({ clientCallType: "H5" }).then((res) => {
        if (res.returnCode == "0000") {
          this.salesInfo = res.data;
        }
      });
    },
    // 销售-按天数查询
    getSales() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      let query = {
        clientCallType: "H5",
        dateRange: this.dateList[this.dateIndex].dateRange,
      };
      console.log("query======", query);
      salesInfoApi(query).then((res) => {
        this.$toast.clear();
        if (res.returnCode == "0000") {
          this.sales = res.data;
        }
      });
    },
    handleBackApp() {
      location.href = "ulemobile://ulePopView";
    },
    appGetPioltFlag() {
      console.log("更新3");
      var _this = this;
      dsBridge.call("getPilotStatus", {
        ios_action: "getPilotStatusResult",
        android_action: "getPilotStatusResult",
      });
      dsBridge.register("getPilotStatusResult", (s) => {
        if (typeof s == "string") {
          s = JSON.parse(s);
        }
        console.log("sssssssssss=", s);
        if (s) {
          _this.cityType = "1";
          _this.dateList = _this.shiList;
          this.getSales();
        } else {
          this.getSales();
        }
      });
    },
  },
};
